var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTianjia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ep:search"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99",
    cx: 7.75,
    cy: 7,
    r: 6.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 693",
    d: "M3.75 7H11.75",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 694",
    d: "M7.75 3L7.75 11",
    stroke: "black",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTianjia);
export default __webpack_public_path__ + "static/media/tianjia.fadc1d29aed83ec9b38bf7af736c1fd6.svg";
export { ForwardRef as ReactComponent };